export default __webpack_public_path__ + "static/Catharina Palupi-9249e482e3c121ba702d61ca16a864a9.png";